import { useFetchResource, useFindLinkByR } from '../../../../../../Fetch';
import { declareEndpoint } from '../../../../../../Links';
import { currentUserStore } from '../../../../../../CurrentUserStore';

export const useBuilder = () => {
  const link = useFindLinkByR(
    { rel: 'new-learning-collection-template-v2', method: 'get' },
    currentUserStore.links,
  );

  const newLearningCollectionState = useFetchResource(
    link.map(declareEndpoint('/new_learning_collection_template')),
  );

  return {
    newLearningCollectionState,
  };
};
